import React, { ReactNode } from "react";

interface PhoneFrameProps {
    children: ReactNode;
    frameColor?: string;
    screenColor?: string;
    notchColor?: string;
    homeButtonColor?: string;
    width?: number;
    height?: number;
}

const PhoneFrameTwo = ({
    children,
    frameColor = "#111",
    screenColor = "white",
    notchColor = "#111",
    homeButtonColor = "#333",
    width = 300,
    height = 600,
}: PhoneFrameProps) => {
    return (
        <div
            style={{
                width: `${width}px`,
                height: `${height}px`,
                background: frameColor,
                borderRadius: "40px",
                position: "relative",
                margin: "50px auto",
                padding: "8px",
                boxShadow:
                    "0 0 0 5px #333, 0 0 0 8px #555, 0 20px 50px rgba(0,0,0,0.8)",
            }}
        >
            <div
                style={{
                    width: "50%",
                    height: "20px",
                    background: notchColor,
                    position: "absolute",
                    top: "0",
                    left: "25%",
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    zIndex: 10,
                }}
            />

            <div
                style={{
                    width: "100%",
                    height: "100%",
                    background: screenColor,
                    borderRadius: "40px",
                    overflow: "hidden",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                        backgroundColor: "#fff",
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                    }}
                >
                    {children}
                </div>
            </div>

            <div
                style={{
                    width: "100px",
                    height: "5px",
                    background: homeButtonColor,
                    position: "absolute",
                    bottom: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    borderRadius: "5px",
                    zIndex: 10,
                }}
            />
        </div>
    );
};

export default PhoneFrameTwo;
